module.exports = __webpack_public_path__ + "img/53_30.16021b94.png";